/**
 * about.js — content module for /about spoke page.
 */

export const aboutHead = {
  eyebrow: 'About',
  heading: 'Sakib Rahman',
  subheading: 'Founder, The Artificer’s AI',
};

export const bio = {
  paragraphs: [
    'Sakib Rahman founded The Artificer’s AI in December 2024 from Perth, Western Australia. The studio builds custom AI automations, fully automated business systems, and enterprise AI training for operators who want AI moving real work through their business, not sitting in a chat window.',
    'He started it on a simple principle: founders should be able to do what they do best, make creative big-picture decisions, without being drowned in busy work. The studio exists to take that work off their desk.',
    'Every engagement starts with the real workflow. Sakib scopes it, builds it, and ships it himself. Clients receive source code, documentation, and infrastructure access at delivery. No subscriptions to the studio, no vendor lock.',
    'Calls are answered by Sakib. Perth time, clients worldwide.',
  ],
};

export const partnerLine = 'Proud Partners of CIEA Australia';

export const aboutCta = {
  label: 'Talk to Merlin',
};

export const aboutLinks = {
  foundry: { href: '/foundry', label: 'The Foundry' },
  automatedSystems: { href: '/automated-systems', label: 'Fully Automated Business Systems' },
  teamTraining: { href: '/team-training', label: 'Team Training' },
  systems: { href: '/systems', label: 'AI-native business systems' },
  process: { href: '/process', label: 'How we ship' },
};
